import React from 'react';
import Warning from 'Common/Components/Warning';
import { Wrapper, ModalWrapper } from 'Common/Components/ConfirmNavigationModal/styled';
import { useIntl } from 'react-intl';
import { StyledMessage, Asterisk } from './styled';
import { useDispatch } from 'react-redux';
import { setCreateVulnError } from 'Screens/Contextualization/ManageEditCreate/actions/Actions';
import useKeypress from 'Hooks/useEscKey';
import { setCreateCredentialError } from 'store/Credentials/actions';

const CreationWarning = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const errorTitle = intl.formatMessage({ id: 'credentials.modalCreateEdit.createTitle' });
  const errorMessage = intl.formatMessage({ id: 'modal.createVuln.cantCreate.message' });

  useKeypress('Escape', () => {
    dispatch(setCreateVulnError(false));
  });

  return (
    <Wrapper>
      <ModalWrapper>
        <Warning
          title={ errorTitle }
          children={ <StyledMessage>{ errorMessage } ( <Asterisk /> )</StyledMessage> }
          onClose={ () => dispatch(setCreateCredentialError(false)) }
        />
      </ModalWrapper>
    </Wrapper>
  );
};

export default CreationWarning;
